import { render, staticRenderFns } from "./UserManagementSettings.vue?vue&type=template&id=21f1edbe&scoped=true"
import script from "./UserManagementSettings.vue?vue&type=script&lang=js"
export * from "./UserManagementSettings.vue?vue&type=script&lang=js"
import style0 from "./UserManagementSettings.vue?vue&type=style&index=0&id=21f1edbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1edbe",
  null
  
)

export default component.exports